'use strict';

/**
 * @deprecated
 */
module.exports = {
	MINECRAFT_JAVA: 'minecraftJava',
	MINECRAFT_PE: 'minecraftPe'
};
